// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import styles from './RegisUnderWeightAlertModal.module.scss';
import { Trans, useTranslation } from 'react-i18next';
import IconWarning from 'components/atoms/icons/IconWarning';
import { normalizeNumber } from 'util/commons';
import { useMemo } from 'react';
import BigNumber from 'bignumber.js';

type RegisUnderWeightAlertModalProps = {
  totalWeight: number | string;
  registeringWeight: number | string;
  remainingWeight: number | string;
  onCancel: () => void;
  onOk: () => void;
};

const RegisUnderWeightAlertModal: React.FC<RegisUnderWeightAlertModalProps> = ({
  totalWeight: totalWeightValue,
  registeringWeight,
  remainingWeight: remainingWeightValue,
  onCancel,
  onOk,
}) => {
  const { t } = useTranslation();

  const { totalWeight, registeredWeight, wastedWeight } = useMemo(() => {
    const getValue = (value: number | string) =>
      Number(value) < 0 ? 0 : value;
    const registeredWeightValue = new BigNumber(totalWeightValue)
      .minus(remainingWeightValue)
      .plus(registeringWeight);
    const wastedWeightValue = new BigNumber(remainingWeightValue).minus(
      registeringWeight
    );

    return {
      totalWeight: normalizeNumber({
        value: getValue(totalWeightValue),
        commaSplit: true,
      }),
      registeredWeight: normalizeNumber({
        value: getValue(registeredWeightValue.toString()),
        commaSplit: true,
      }),
      wastedWeight: normalizeNumber({
        value: getValue(wastedWeightValue.toString()),
        commaSplit: true,
      }),
    };
  }, [totalWeightValue, registeringWeight, remainingWeightValue]);

  return (
    <Modal isSmall centered>
      <div className={styles.modalContent}>
        <div>
          <IconWarning />
        </div>

        <p className={styles.alertContent}>
          <Trans
            t={t}
            i18nKey="pre_regist_resource_select.over_weight_alert"
            components={{
              strong: <strong />,
            }}
            values={{
              totalWeight,
              registeredWeight,
              wastedWeight,
            }}
          />
        </p>

        <div className={styles.btnBox}>
          <button type="button" onClick={onCancel} className={styles.cancelBtn}>
            {t('common.return')}
          </button>
          <button type="button" onClick={onOk} className={styles.okBtn}>
            {t('common.button.ok')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RegisUnderWeightAlertModal;
